<script lang="ts">
  import Avatar from '../Avatar.svelte';
  import { onActivateKeydown } from './interactions';
  import type { MessagingUser } from './api';

  export let contact: MessagingUser;
  export let collapsed: boolean;
  export let onSelect: () => void;

  $: label = `${contact.first_name} ${contact.last_name}`;
</script>

{#if collapsed}
  <div class="group flex justify-center py-2" role="button" tabindex="0" title={label} on:click={onSelect} on:keydown={(e) => onActivateKeydown(e, onSelect)}>
    <div class="rounded-full transition-shadow group-hover:ring-2 group-hover:ring-border group-hover:ring-offset-2 group-hover:ring-offset-card">
      <Avatar profile_photo={contact.profile_photo} first_name={contact.first_name} last_name={contact.last_name} username={contact.username} shape="circle" pad_right={false} />
    </div>
  </div>
{:else}
  <div
    class="flex cursor-pointer items-center gap-3 px-4 py-3 transition-colors hover:bg-accent"
    role="button"
    tabindex="0"
    on:click={onSelect}
    on:keydown={(e) => onActivateKeydown(e, onSelect)}
  >
    <Avatar profile_photo={contact.profile_photo} first_name={contact.first_name} last_name={contact.last_name} username={contact.username} shape="circle" pad_right={false} />
    <span class="truncate text-sm font-medium text-foreground">{label}</span>
  </div>
{/if}
